// Finite vocabulary only: no identities, financial values, URLs or error text.
const events = ['crash','unhandled','sync_failure','slow_request','storage_failure'] as const;
const areas = ['app','sync','auth','request','storage'] as const;
const codes = ['unknown','network','timeout','quota','render','server','storage'] as const;
const durations = ['under_2s','2_to_5s','5_to_15s','over_15s'] as const;
export interface HealthEvent {
  event: typeof events[number]; area: typeof areas[number]; code: typeof codes[number];
  duration?: typeof durations[number]; release: string;
}
export function parseHealthEvent(value: unknown): HealthEvent | null {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  const data = value as Record<string, unknown>;
  if (Object.keys(data).some(key => !['event','area','code','duration','release'].includes(key))) return null;
  if (!(events as readonly unknown[]).includes(data.event) || !(areas as readonly unknown[]).includes(data.area) || !(codes as readonly unknown[]).includes(data.code)) return null;
  if (data.duration !== undefined && !(durations as readonly unknown[]).includes(data.duration)) return null;
  if (typeof data.release !== 'string' || !/^[a-zA-Z0-9._-]{1,80}$/.test(data.release)) return null;
  return data as unknown as HealthEvent;
}
